import { COMPUTER_TASKS_HREF } from '#pplx/frontend/apps/ask/layout/sidebar/core/shared/constants.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { defineMessages } from 'react-intl';
const computerTabMessages = defineMessages({
    tasks: {
        defaultMessage: 'Tasks',
        description: 'Tab label for the tasks section in the computer sidebar',
        id: '69e7cc7f14',
    },
    automations: {
        defaultMessage: 'Automations',
        description: 'Tab label for the automations page in the computer sidebar',
        id: '549afb9a19',
    },
    artifacts: {
        defaultMessage: 'Artifacts',
        description: 'Tab label for the artifacts section in the computer sidebar',
        id: '7a3a65b22e',
    },
    connectors: {
        defaultMessage: 'Connectors',
        description: 'Tab label for the connectors section in the computer sidebar',
        id: '27fee14783',
    },
    skills: {
        defaultMessage: 'Skills',
        description: 'Tab label for the skills section in the computer sidebar',
        id: '9aa1b10076',
    },
    gallery: {
        defaultMessage: 'Use cases',
        description: 'Tab label for the use cases section in the computer sidebar',
        id: '93faab88eb',
    },
    workflows: {
        defaultMessage: 'Workflows',
        description: 'Tab label for the workflows section in the computer sidebar',
        id: 'c9845be423',
    },
    context: {
        defaultMessage: 'Memory',
        description: 'Tab label for the memory section in the computer sidebar',
        id: '8826ff221d',
    },
});
export const COMPUTER_WORKFLOWS_TAB = {
    messageDescriptor: computerTabMessages.workflows,
    icon: $icon('route-square'),
    href: '/computer/workflows',
    id: 'computer_workflows',
};
export const COMPUTER_CONTEXT_TAB = {
    id: 'computer_context',
    messageDescriptor: computerTabMessages.context,
    icon: $icon('folder-search'),
    href: '/computer/memory',
};
export const COMPUTER_CONNECTORS_TAB = {
    id: 'computer_connectors',
    messageDescriptor: computerTabMessages.connectors,
    icon: $icon('plug'),
    href: '/computer/connectors',
};
export const COMPUTER_TABS = [
    {
        messageDescriptor: computerTabMessages.tasks,
        icon: $icon('square-rounded-check'),
        href: COMPUTER_TASKS_HREF,
        id: 'computer_tasks',
    },
    {
        messageDescriptor: computerTabMessages.automations,
        icon: $icon('calendar'),
        href: '/computer/automations',
        id: 'computer_automations',
    },
    {
        messageDescriptor: computerTabMessages.artifacts,
        icon: $icon('files'),
        href: '/computer/artifacts',
        id: 'computer_artifacts',
    },
    COMPUTER_CONNECTORS_TAB,
    {
        messageDescriptor: computerTabMessages.skills,
        icon: $icon('blocks'),
        href: '/computer/skills',
        id: 'computer_skills',
    },
    COMPUTER_WORKFLOWS_TAB,
    {
        messageDescriptor: computerTabMessages.gallery,
        icon: $icon('layout-collage'),
        href: '/computer/gallery',
        id: 'computer_live_feed',
    },
    COMPUTER_CONTEXT_TAB,
];
export const getComputerActiveTab = (pathname) => {
    const computerSegment = pathname.split('/')[2];
    switch (computerSegment) {
        case 'new':
            return 'computer_tasks';
        case 'automations':
            return 'computer_automations';
        case 'artifacts':
            return 'computer_artifacts';
        case 'connectors':
            return 'computer_connectors';
        case 'skills':
            return 'computer_skills';
        case 'workflows':
            return 'computer_workflows';
        case 'gallery':
            return 'computer_live_feed';
        case 'memory':
            return 'computer_context';
        default:
            return 'computer_tasks';
    }
};
//# sourceMappingURL=ComputerTabs.js.map